import React from 'react';
import FeedContainerSimple from './FeedContainerSimple.jsx';
import _ from 'lodash';
import { connect } from 'react-redux';
import { appContext } from '../../util/decorators';

const mapStateToProps = state => ({
  popularVideos: state.dataSources.popularVideos,
  routeParams: state.routeParams,
  country: state.country,
});

@connect(mapStateToProps)
@appContext
export default class PopularVideos extends React.PureComponent {
  render() {
    const { popularVideos, routeParams, country } = this.props;

    if (_.isEmpty(_.head(popularVideos))) return null;

    let useVideoTypeTags = false;
    let subHeading = routeParams.sports;
    if (routeParams.teams) {
      const teamTags = _.get(popularVideos, 'tags.teams');
      const teamTag = _.find(teamTags, tag => (tag[country] || tag.en).slug === routeParams.teams);
      subHeading = _.get(teamTag, `${country}.name`) || _.get(teamTag, 'en.name');
      useVideoTypeTags = true;
    } else if (routeParams.competitions) {
      subHeading = _.get(popularVideos, `[0].tags.competitions[0].${country}.name`);
      useVideoTypeTags = true;
    }

    const rows = _.chunk(popularVideos, 2);

    return (
      <div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/NewsFeed/PopularVideos.jsx